
import AppListItemPlaceholder from '@components/new-styleguide/AppListItemPlaceholder.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import SettingItemsView from './SettingsItemView.vue'

@Component({
  name: 'SettingsPanel',
  components: {
    SettingItemsView,
    AppListItemPlaceholder
  }
})
export default class SettingsPanel extends Vue {
  @Prop()
  private headerText: string;

  @Prop({ default: false })
  private loading: boolean;

  @Prop({ default: false })
  private doubleLineLoading: boolean;

  get placeholdersAmount() {
    return 4
  }

  get hasHeaderText() {
    return this.headerText || this.$slots.headerText;
  }
}
